import { FONT, COLORS } from "../../styles";

export default function KPICard({ label, value, sub, color = COLORS.primary }) {
  return (
    <div style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: "18px 20px", position: "relative", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
      <div style={{ position: "absolute", top: 0, left: 0, width: 3, height: "100%", background: color, borderRadius: "3px 0 0 3px" }} />
      <div style={{ fontSize: 12, fontWeight: 500, color: COLORS.muted, marginBottom: 6, fontFamily: FONT }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color: COLORS.text, fontFamily: FONT }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: COLORS.dim, marginTop: 4, fontFamily: FONT }}>{sub}</div>}
    </div>
  );
}
